module.exports = __webpack_public_path__ + "static/media/Lens_Card_KO.68236568.jpg";